import React, {useContext, useEffect, useRef, useState} from "react";
import "../Emails.scss";

import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import AuthContext from "../../../context/AuthProvider";
import {Navbar} from "../../../components/Navbar/Navbar";
import {Alert} from "react-bootstrap";
import parse from "html-react-parser";
import ListGroup from "react-bootstrap/ListGroup";
import Form from "react-bootstrap/Form";
import MultiDropdownNew from "../../../components/dropDown/MultiDropdownNew";
import paymentIcon from "../../../assets/images/switch_app.png";
import {PrimaryButton} from "../../../components/button";
import {getTopUpIndex} from "../../../store/actions/adminActions";
import {toggleInviteModal, toggleRecipientType} from "../../../store/slices/adminSlice";
import { EditorProvider, FloatingMenu, BubbleMenu } from '@tiptap/react'
import {StarterKit} from "@tiptap/starter-kit";
import TipTap from "../../../components/TextEditor/TipTap";
import {toast} from "react-toastify";
import {DEFAULT_ERROR, REGISTER_PARTNER_URL, SEND_EMAIL_URL} from "../../../api/urls";
import useApi from "../../../hooks/useApi";
import {useNavigate} from "react-router-dom";



export const Compose = ({ isAdmin }) => {

  const useDesktopMediaQuery = () =>
    useMediaQuery({ query: "(min-width: 769px)" });

  const useTabletAndBelowMediaQuery = () =>
    useMediaQuery({ query: "(max-width: 768px)" });

  const Desktop = ({ children }) => {
    const isDesktop = useDesktopMediaQuery();
    return isDesktop ? children : null;
  };

  const TabletAndBelow = ({ children }) => {
    const isTabletAndBelow = useTabletAndBelowMediaQuery();
    return isTabletAndBelow ? children : null;
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleSetShow = () => setShow(true);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const { user, isLoggedIn } = useContext(AuthContext);
  const { adminsdata,businessdata } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const [filterData, setFilterData] = useState({ search: "" });
  const searchInit = useRef("");
  const isOpenInit = useRef(false);
  const isEmailAnalysis = useRef(false);
  const currentMsg = useRef("");
  const selectedUsers = useRef([]);
  const navigate = useNavigate();
  let errorMsg;
  let successMsg;
  const subjectRef = useRef();
  const [isLoading, setIsLoading] = useState();
  const emailAnalysisFilter = JSON.parse(localStorage.getItem(`emailAnalysisFilters`) || "{}");
  const [form, setForm] = useState({
    type: emailAnalysisFilter.isAnalysis?3:2,
    emails: [],
  });
  let users:any = [];
  const api = useApi();


  // console.log(businessdata);
  const handleGoToNext = (page) => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleGoToPrev = () => {
    setCurrentPage((prev) => prev - 1);
  };

  const handleResetCurrentPage = () => {
    setCurrentPage((prev) => 1);
  };

  const handleSetFilter = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
    // handleSearch();
  };

  const handleSearch = () => {
    const data = { pageSize, currentPage };

    data.isSearch = true;
    // if (filterData.search.length > 0) data.search = filterData.search;
    handleApiData(data);
  };

  const handleApiData = (data) => {
    const filters = JSON.parse(localStorage.getItem(`flaggedFilters`) || "{}");
    if (filters.subjectFilter && filters.subjectFilter.length > 0) {
      data.subject = filters.subjectFilter;
    }

    if (filters.typeFilter && filters.typeFilter.length > 0) {
      data.type = filters.typeFilter;
    }
    if (filters.yearFilter && filters.yearFilter.length > 0) {
      data.year = filters.yearFilter;
    }
    if (filters.searchFilter && filters.searchFilter.length > 0) {
      data.search = filters.searchFilter;
    }
    if (filters.sort && filters.sort.length > 0) {
      data.sort = filters.sort;
    } else {
      data.sort = "Pending";
    }
    if (isAdmin && adminsdata.types.length === 0) data.is_filter = true;
    data.isAdmin = isAdmin;
    if (data.isSearch) {
      handleResetCurrentPage();
      data.currentPage = 1;
    }
    // console.log(data.isAdmin,adminsdata.types,data);
    // dispatch(getSentEmails(data));
  };




  const handleChangedType = (e)=> {
    setForm({
      ...form,
      type: +e.target.value,
    });
    handleChangedRecipientType(+e.target.value);
  }


  const handleChangedRecipientType = (type)=> {
    if(type === 1){
      dispatch(toggleRecipientType());
    }
    else{
      searchFilter("");
    }
    localStorage.removeItem("multi-selected");
  }



  const handleTester = ()=> {
    setForm({
      ...form,
      subject: "new one",
    });
    // console.log("i am called")
  }
  const handleChangedValue = (e)=> {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  }

  const handleComboChanged = (usersList)=> {
    // console.log("handleComboChanged ",usersList);
    selectedUsers.current = usersList;
    // setForm({
    //   ...form,
    //   emails: usersList,
    // });
  }

  const searchFilter = (search,isClose=false) => {
    if(isClose){
      isOpenInit.current = false;
      searchInit.current = "";
      // console.log("searchFilter2",search,searchInit.current,isOpenInit.current);
      return;
    }
    isOpenInit.current = true;
    searchInit.current = search;
    dispatch(getTopUpIndex({search:search }));
    // console.log("searchFilter",search,searchInit.current,isOpenInit.current);
  }

  const handleEditorChange = (str)  => {
    currentMsg.current = str;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!subjectRef.current.value) {
      toast.error("Subject is required");
    } else if (!!!selectedUsers.current.length && form.type != 3) {
      toast.error("Recipient is required");
    }else if (!currentMsg.current) {
      toast.error("Message is required");
    }
    else{
      let emails = selectedUsers.current;
      if(form.type === 1){
        emails = selectedUsers.current[0];
      }
      else if(form.type === 3){
        emails = emailAnalysisFilter;
        // console.log(emailAnalysisFilter);
      }
      await sendMail({
        subject: subjectRef.current.value,
        emails: emails,
        message: currentMsg.current,
        type: form.type,
      });
    }
  }

  const sendMail = async (payload) => {
    try {
      // console.log("Payload: ",payload);
      setIsLoading(true);
      const resp:any  = await api.post(SEND_EMAIL_URL, payload);
      // console.log("Payload: ",resp);
      toast.success(
          resp.data.success
      );
      setIsLoading(false);
      navigate("/admin/emails",{replace: true});
    } catch (error) {
      toast.error(getErrorMessage(error));
      setIsLoading(false);
    }
  };

  const getErrorMessage = (error) => {
    // console.log("error: ",error);
    let msg  = (error?.response?.status === 403 && error?.response?.data) || error.response.statusText;
    if(error?.response?.data && typeof error.response.data === 'object'
        && error.response.data.error){
      msg = error.response.data.error;
    }
    return (error?.response?.status !== 404 && msg) || DEFAULT_ERROR;
  };

  useEffect(() => {
    dispatch(getTopUpIndex({ }));
    // console.log(emailAnalysisFilter,isEmailAnalysis.current,
    //     form);
    handleChangedRecipientType(+form.type);
    return (() => {
      localStorage.removeItem("multi-selected");
      // localStorage.removeItem("emailAnalysisFilters");
    })
  }, []);


  return (
    <>
      <div>{isAdmin ? "" : <Navbar />}</div>
      {/*<Desktop>*/}
        <div className="flag-cls compose col-md-10 offset-md-1">
          <div className="flexy flexyM search-bar mt6">
            <div className="col-md-8 offset-md-2">
              <div className="lisxt ">
                <b>Send Email</b>
              </div>
              <div className="panels" style={{ position: "relative",marginTop: "1rem"}}>
                <div className="col-md-8 offset-md-2">

                  <div className="form-container">
                    <Alert show={!!errorMsg} variant={successMsg?"success":"danger"}>
                      <p>
                        {/*{errorMsg && parse(errorMsg)}*/}
                      </p>
                    </Alert>

                    <>
                      <h6 className="form-heading">
                        New Message
                      </h6>
                      <ListGroup>
                        <ListGroup.Item>
                          <div className="mb-3">
                            <>
                              <Form.Label className={"vHead"} htmlFor="sid">
                                <b>Select Recipient Type</b>
                              </Form.Label>
                              <Form.Select
                                  defaultValue={form.type}
                                  placeholder={"Select Recipient Type"}
                                  disabled={form.type == 3}
                                  onChange={handleChangedType}>
                                <option value="2">Individual</option>
                                <option value="1">Group</option>
                                {form.type == 3?(
                                    <option value="3">Custom</option>
                                ):""}

                              </Form.Select>
                            </>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item>
                          {form.type != 3?(
                              <div className="mb-3">
                                <>
                                  <Form.Label className={"vHead"} htmlFor="sid">Recipients</Form.Label>
                                  <MultiDropdownNew
                                      type={form.type} selectedValues={selectedUsers.current}
                                      handleChange={handleComboChanged}
                                      options={businessdata.learners} searchFilter={searchFilter}
                                      isOpenInit={isOpenInit.current} searchInit={searchInit.current}>
                                  </MultiDropdownNew>
                                  <Form.Text id="sid" muted>
                                    {/*Note: Minimum to purchase is 5000Unit*/}
                                  </Form.Text>
                                </>
                              </div>
                          ):""}

                          <div className={"mInstructions"}>
                            <h4>Instructions</h4>
                            <ul>
                              <li>Use <b>~first~</b> where you want the First name to appear</li>
                              <li>Use <b>~last~</b> where you want the Last name to appear.</li>
                              <li>Use <b>~email~</b> where you want the Email to appear.</li>
                              <li>Use <b>~fullname~</b> where you want the Full name to appear.</li>
                            </ul>
                          </div>
                          <div className="mb-3">
                            <>
                              <Form.Label className={"vHead"} htmlFor="qid">Subject</Form.Label>
                              <Form.Control
                                  type="text"
                                  id="qid"
                                  step={1}
                                  name="subject"
                                  defaultValue={subjectRef?.current?.value}
                                  ref={subjectRef}
                                  placeholder={"Subject"}
                              />
                            </>
                          </div>
                          <div className="mb-3">
                            <>
                              <Form.Label className={"vHead"} htmlFor="qid">Enter you Mail message:</Form.Label>
                              <TipTap OnChange={handleEditorChange} content={currentMsg.current} />
                            </>
                          </div>

                        </ListGroup.Item>



                      </ListGroup>

                      {" "}
                      <div className={'mbtn-action-group'}>
                        <PrimaryButton
                            to="/admin/emails"
                            // onClick={handleTester}
                            size="sm" className="formButtonActive formbutton mback">Back</PrimaryButton>
                        <PrimaryButton onClick={handleSubmit} isLoadingMsg="Processing..." size="sm" className="formButtonActive formbutton" isLoading={isLoading}>Send</PrimaryButton>

                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      {/*</Desktop>*/}
      {/*<TabletAndBelow>*/}
      {/*  <div className="flag-cls  mobile-ms">*/}

      {/*  </div>*/}
      {/*</TabletAndBelow>*/}
    </>
  );
};
